module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\"><rect width=\"12\" height=\"2\" y=\"5\" fill=\"#FFF\" rx=\"1\"></rect></svg>"